import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from '@/lib/contexts/auth-context'
import { TRPCProvider } from '@/providers/TRPCProvider'
import { AuthGuard } from '@/components/auth/AuthGuard'
import { AppLayout } from '@/components/layout/AppLayout'
import { LoginPage } from '@/app/login/page'
import { DealsPage } from '@/app/deals/page'
import { NewDealPage } from '@/app/deals/new/page'
import { DealDetailPage } from '@/app/deals/[id]/page'
import { ComparePage } from '@/app/compare/page'
import { SettingsPage } from '@/app/settings/page'

export default function App() {
  return (
    <TRPCProvider>
      <AuthProvider>
        <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          element={
            <AuthGuard>
              <AppLayout />
            </AuthGuard>
          }
        >
          <Route index element={<Navigate to="/deals" replace />} />
          <Route path="/deals" element={<DealsPage />} />
          <Route path="/deals/new" element={<NewDealPage />} />
          <Route path="/deals/:id" element={<DealDetailPage />} />
          <Route path="/compare" element={<ComparePage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
      </Routes>
      </AuthProvider>
    </TRPCProvider>
  )
}
